export function enable(state) {
  state.enabled = true;
}

export function setDebugger(state, debug) {
  state.debug = debug;
}
